import { Empty, Spin } from 'antd'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Select from 'components/Select/index'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import DeleteIcon from 'components/icons/DeleteIcon'
import RedDotIcon from 'components/icons/RedDotIcon'
import ReplaceIcon from 'components/icons/ReplaceIcon'
import {
  ClikcEvent,
  CollageDetailsFlex,
  CollageNameFlex,
  CollegeCity,
  CollegeNameDiv,
  EmtyWrapper,
  FooterFlex,
  HeaderFlex,
  InterviewerDiv,
  SearchDiv,
} from 'modules/Exp-Candidates/ViewDriveRole/AddInterviewerDrawer/style'
import React, { Fragment, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import ReplaceDrawer from './ReplaceDrawer'
import {
  CollageDetailsFlexing,
  CollegeNameDivText,
  ReplaceTextDiv,
} from './style'

const AddInterviewer = ({
  addInterviewerDrawer,
  setAddInterviewerDrawer,
  getInterviewerList,
  updateInterview,
  getDriveInterviewerList,
  interViewerList,
  driveInterViewerList,
  driveId,
  addInterviewer,
  deleteInterviewer,
  setAddReplaceDrawer,
  addReplaceDrawer,
}) => {
  const params = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingAdd, setIsLoadingAdd] = useState(false)
  const [isLoadingList, setIsLoadingList] = useState(false)
  const [selectedInterviewerId, setSelectedInterviewerId] = useState([])
  const [interviewerName, setInterviewerName] = useState('')
  const [search, setSearch] = useState('')
  const [newInterViewer, setNewInterViewer] = useState()
  const [checked, setChecked] = useState(null)
  const [interViewerId, setInterViewerId] = useState(null)
  const getInterviewer = async (searchValue, expcandidatesId) => {
    setIsLoading(true)
    await getInterviewerList(searchValue, expcandidatesId)
    setIsLoading(false)
  }

  const getDriveInterviewer = async driveId => {
    setIsLoadingList(true)
    await getDriveInterviewerList(driveId)
    setIsLoadingList(false)
  }

  useEffect(() => {
    getInterviewer(search, params.expcandidatesId)
  }, [search, params.expcandidatesId])

  useEffect(() => {
    getDriveInterviewer(params.expcandidatesId)
  }, [params.expcandidatesId])

  const onSelectInterviewer = data => {
    let InterviewerId = data[data?.length - 1]
    let Name
    interViewerList?.map(item => {
      if (item?._id === InterviewerId) {
        let firstName = item?.first_name
        let lastName = item?.last_name
        Name = `${firstName} ${lastName}`
      }
    })
    setInterviewerName(Name)
    setSelectedInterviewerId(data?.length !== 0 ? [data[data?.length - 1]] : [])
  }

  const onSearchInterviewer = data => {
    setSearch(data)
  }

  const UpdateInterviewer = async () => {
    setIsLoadingAdd(true)
    let payload = { interviewerId: newInterViewer?._id }
    let response = await updateInterview(
      params.expcandidatesId,
      interViewerId,
      payload
    )
    if (response.status >= 200 && response.status <= 300) {
      SuccessMessage('Interviewer Updated successfully!')
      getDriveInterviewer(params.expcandidatesId)
      setAddInterviewerDrawer(false)
    } else {
      setAddInterviewerDrawer(false)
      setIsLoadingAdd(false)
    }
  }

  const onAddInterviewer = async () => {
    if (selectedInterviewerId?.length > 0) {
      setIsLoadingAdd(true)
      let payLoad = {
        interviewerName: interviewerName,
      }
      let response = await addInterviewer(
        params.expcandidatesId,
        selectedInterviewerId.join(),
        payLoad
      )
      if (response.status >= 200 && response.status <= 300) {
        setSelectedInterviewerId([])
        SuccessMessage('Interviewer added successfully!')
        getDriveInterviewer(params.expcandidatesId)
        setIsLoadingAdd(false)
      } else {
        ErrorMessage(response?.response?.data?.message)
        setIsLoadingAdd(false)
      }
    }
  }

  const onDeleteInterviewer = async id => {
    let response = await deleteInterviewer(params.expcandidatesId, {
      interviewerId: id,
    })
    if (response.status >= 200 && response.status <= 300) {
      SuccessMessage('Interviewer deleted successfully!')
      getDriveInterviewer(params.expcandidatesId)
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const onClose = () => {
    setAddInterviewerDrawer(false)
    setSelectedInterviewerId([])
  }

  const handleReplace = value => {
    setAddReplaceDrawer(true)
    getDriveInterviewer(params.expcandidatesId)
    setInterViewerId(value)
  }

  const handleGoBack = () => {
    setAddInterviewerDrawer(false)
  }

  const content = () => {
    return (
      <>
        <HeaderFlex spaceBetween centerVertically>
          <SearchDiv>
            <Select
              filterOption={false}
              isSearchSelect={true}
              placeholder="Search Members"
              OptionData={interViewerList}
              valueParam="_id"
              nameParam="first_name"
              lastNameParam="last_name"
              mode="multiple"
              onChange={onSelectInterviewer}
              value={selectedInterviewerId}
              optionLabelProp={'label'}
              menuItemSelectedIcon={''}
              showSearch={true}
              onSearch={onSearchInterviewer}
              onBlur={() => setSearch('')}
              notFoundContent={
                isLoading ? (
                  <CollageDetailsFlex alignCenter center isBoader={true}>
                    <Spin />
                  </CollageDetailsFlex>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={'Interviewer not found!'}
                  />
                )
              }
            />
          </SearchDiv>
          <div>
            <Button.Primary
              width="69px"
              height="38px"
              text="Add"
              loading={isLoadingAdd}
              onClick={onAddInterviewer}
            />
          </div>
        </HeaderFlex>
        {newInterViewer ? (
          <>
            {driveInterViewerList?.map((interviewer, index) => {
              return (
                <>
                  {interViewerId === interviewer?._id && (
                    <CollageDetailsFlexing spaceBetween centerVertically>
                      <Flex alignCenter>
                        <AntdAvatar
                          size={36}
                          IconName={interviewer?.first_name
                            ?.charAt(0)
                            ?.toUpperCase()}
                        />

                        <CollageNameFlex>
                          <CollegeNameDiv>
                            {interviewer?.first_name} {interviewer?.last_name}
                          </CollegeNameDiv>
                          <CollegeCity>{interviewer?.email}</CollegeCity>
                        </CollageNameFlex>
                      </Flex>
                      <Flex alignCenter>
                        {}
                        <ReplaceIcon />
                        {}
                      </Flex>

                      {newInterViewer ? (
                        <Flex alignCenter key={newInterViewer._id}>
                          <AntdAvatar
                            size={36}
                            IconName={newInterViewer?.first_name
                              ?.charAt(0)
                              ?.toUpperCase()}
                          />
                          <CollageNameFlex>
                            <CollegeNameDiv>
                              {newInterViewer?.first_name}{' '}
                              {newInterViewer?.last_name}
                            </CollegeNameDiv>
                            <CollegeCity>{newInterViewer?.email}</CollegeCity>
                          </CollageNameFlex>
                        </Flex>
                      ) : (
                        ''
                      )}
                    </CollageDetailsFlexing>
                  )}
                </>
              )
            })}
          </>
        ) : null}
        {driveInterViewerList?.length > 0 ? (
          <Fragment>
            <InterviewerDiv>
              Added Interviewers(
              {getZeroBeforeInt(driveInterViewerList?.length)})
            </InterviewerDiv>
            {newInterViewer ? (
              <Flex alignCenter key={newInterViewer._id}>
                <AntdAvatar
                  size={36}
                  IconName={newInterViewer?.first_name
                    ?.charAt(0)
                    ?.toUpperCase()}
                />
                <CollageNameFlex>
                  <CollegeNameDivText>
                    {newInterViewer?.first_name} {newInterViewer?.last_name}{' '}
                    {<RedDotIcon />}{' '}
                    {<ReplaceTextDiv>{'Replaced'}</ReplaceTextDiv>}
                  </CollegeNameDivText>
                  <CollegeCity>{newInterViewer?.email}</CollegeCity>
                </CollageNameFlex>
              </Flex>
            ) : (
              ''
            )}
            {driveInterViewerList?.map((interviewer, index) => {
              return (
                <CollageDetailsFlex
                  spaceBetween
                  centerVertically
                  isBoader={driveInterViewerList?.length - 1 === index}
                  key={index + interviewer?.first_name}
                >
                  <Flex alignCenter>
                    <AntdAvatar
                      size={36}
                      IconName={interviewer?.first_name
                        ?.charAt(0)
                        ?.toUpperCase()}
                    />

                    <CollageNameFlex>
                      <CollegeNameDiv>
                        {interviewer?.first_name} {interviewer?.last_name}
                      </CollegeNameDiv>
                      <CollegeCity>{interviewer?.email}</CollegeCity>
                    </CollageNameFlex>
                  </Flex>
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'center',
                    }}
                  >
                    <Button.Secondary
                      text="Replace"
                      onClick={() => handleReplace(interviewer?._id)}
                    />
                    <ClikcEvent
                      onClick={() => onDeleteInterviewer(interviewer?._id)}
                    >
                      <DeleteIcon />
                    </ClikcEvent>
                  </div>
                </CollageDetailsFlex>
              )
            })}
          </Fragment>
        ) : (
          <EmtyWrapper center>
            {!isLoadingList ? (
              <Empty description={'please add a interviewer to this drive!'} />
            ) : (
              <Spin />
            )}
          </EmtyWrapper>
        )}
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Cancel"
          onClick={handleGoBack}
        />
        <Button.Primary
          width="95px"
          height="38px"
          text="Confirm"
          loading={isLoadingAdd}
          onClick={UpdateInterviewer}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="40%"
        title={'Add / Replace Interviewer'}
        placement="right"
        visible={addInterviewerDrawer}
        content={content()}
        footer={footer()}
        onClose={onClose}
        closable
      />
      <ReplaceDrawer
        setAddReplaceDrawer={setAddReplaceDrawer}
        addReplaceDrawer={addReplaceDrawer}
        setChecked={setChecked}
        getInterviewerList={getInterviewerList}
        checked={checked}
        driveInterViewerList={driveInterViewerList}
        interViewerList={interViewerList}
        interViewerId={interViewerId}
        setSelectedInterViewerId={setSelectedInterviewerId}
        selectedInterviewerId={selectedInterviewerId}
        newInterViewer={newInterViewer}
        setNewInterViewer={setNewInterViewer}
      />
    </>
  )
}

export default AddInterviewer
